import React from 'react';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';

const styles = theme => ({
  feature: {
    backgroundColor: '#ECF0F2',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '15vh',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  allType: {
    maxWidth: '550px',
    padding: '1rem',
    [theme.breakpoints.down('md')]: {
      marginTop: '40px',
      marginRight: '0',
      width: '80%',
    },
  },
  heading: {
    marginBottom: '20px',
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '2rem',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '2.5rem',
    },
  },
  description: {
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '1.5rem',
    },
  },
  img: {
    width: '90%',
    marginTop: '1rem',
    [theme.breakpoints.down('md')]: {
      width: '80%',
    },
    boxShadow: `0 5px 10px #0009`,
  },
});

function FeatureContent({ classes, content }) {
  return (
    <div className={classes.feature}>
      <img src={content.screenshot} alt="MediVI screenshot" className={classes.img} />
      <div className={classes.allType}>
        <Typography variant="h4" className={classes.heading}>
          {content.title}
        </Typography>
        <Typography className={classes.description}>{content.description}</Typography>
      </div>
    </div>
  );
}

FeatureContent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  content: PropTypes.shape({
    description: PropTypes.string,
    screenshot: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default withStyles(styles)(FeatureContent);
